import { VetologyBase } from '../Vetology/VetologyBase'

export class PrivacyAgreement extends VetologyBase
{
	constructor ()
	{
		super('PrivacyAgreement');

		const _self = this;
		_self.modal = null;
	}

	init ()
	{
		const _self = this;

		_self.initEventHandlers();

		const modalElement = document.getElementById('privacy-agreement-modal');
		// have to use a bit of jquery here... only way to create BS3 modal
		_self.modal = $(modalElement).modal({
			show: true,
			backdrop: 'static'
		});
	}

	initEventHandlers()
	{
		const _self = this;
		const modal = document.getElementById('privacy-agreement-modal');

		_self.onShowModal = _self.onShowModal.bind(_self);
		modal.addEventListener('show.bs.modal', _self.onShowModal);

		_self.onHideModal = _self.onHideModal.bind(_self);
		modal.addEventListener('hide.bs.modal', _self.onHideModal);

		_self.onClickAcceptAndClose = _self.onClickAcceptAndClose.bind(_self);
		const acceptBtn = modal.querySelector('button#accept-policy-button');
		acceptBtn.addEventListener('click', _self.onClickAcceptAndClose);
	}

	removeEventHandlers()
	{
		const _self = this;
		const modal = document.getElementById('privacy-policy-modal');

		modal.removeEventListener('show.bs.modal', _self.onShowModal);

		modal.removeEventListener('hide.bs.modal', _self.onHideModal);

	}

	onShowModal(event)
	{
		const _self = this;

	}

	onHideModal(event)
	{
		const _self = this;


	}

	onClickAcceptAndClose(event)
	{
		const _self = this;

		const buttonElem = event.target;
		const userID = buttonElem.dataset['uid'];
		const formData = new FormData();
		formData.append('userID', userID);
		// update user's record with the policy acceptance date
		fetch('/user/update-privacy-policy-acceptance', {
			method: 'post',
			body: formData
		}).then(response => {
			if (response.ok) {
				toastr.success('Thank you for accepting our Privacy Policy');
			} else {
				toastr.error('Something went wrong while updating our records...  You will be required to accept our latest policy assignment again.')
			}
		});
	}

}
